
































import { Component, Vue, Prop } from 'vue-property-decorator'
import { ExStore } from 'vuex'
import { TabInfoChild } from '@/types/appSettings'
import { Tabs, TabSettingName } from '@/constants/appSettings'

@Component
export default class TabFrame extends Vue {
  @Prop(Number) patientId!: number

  $store!: ExStore

  get tabSettings() {
    return this.$store.getters['appSettings/displayTabs']
  }

  get tabs() {
    return Tabs
  }

  findTab(routeName: string) {
    const keys = Object.keys(Tabs) as Array<keyof typeof TabSettingName>

    for (let i = 0; i < keys.length; i++) {
      if (Tabs[keys[i]].routeName === routeName) {
        return Tabs[keys[i]]
      }

      if (!Tabs[keys[i]].children) {
        continue
      }

      const child = (Tabs[keys[i]].children as TabInfoChild[]).find(
        child => child.routeName === routeName
      )

      if (child) {
        return Object.assign({}, Tabs[keys[i]], child)
      }
    }
  }

  get currentTab() {
    return this.findTab(this.$route.name || '')
  }

  get currentPatient() {
    return this.$store.getters['patient/currentPatient']
  }

  get displayPatient() {
    if (!this.currentPatient) {
      return ''
    }

    const {
      firstName,
      lastName,
      lastNameReading,
      firstNameReading,
      genderDisplay,
      age
    } = this.currentPatient

    return `${lastName} ${firstName}(${lastNameReading} ${firstNameReading}) /${genderDisplay}/${age}歳`
  }

  get currentTabTitle() {
    if (this.$route.name === 'HdTab') {
      return this.$store.getters['hd/hdType']
    }
    return this.currentTab?.title
  }
}
